module.exports = __webpack_public_path__ + "createstatic/media/EMPTY-STATE.9507c91b.jpg";